import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { Grid, Typography, Card, CardContent, Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';
import UpdateIcon from '@material-ui/icons/Update';
import Controls from '../controls/Controls';
import { useClientContext } from '../../context/client_context';
import { baseUrl } from '../../utils/constants';

export default function Affordability() {
  const { clientRefId, clientAffordability } = useClientContext();
  const [totExpenses, setTotExpenses] = useState('');
  const [affordData, setAffordData] = useState(null);

  // console.log('form at beginning', formData);
  const AffordabilitySchema = Yup.object().shape({
    grossSalary: Yup.number().required('Gross Salary is required'),
    netSalary: Yup.number().required('Net Salary is required'),
    expensesHousing: Yup.number(),
    expensesTransport: Yup.number(),
    expensesMedical: Yup.number(),
    expensesWater: Yup.number(),
    expensesOther: Yup.number(),
    expensesOtherDebt: Yup.number(),
    expensesEducation: Yup.number()
  });

  // const initialValue = {
  //   grossSalary: clientAffordability.grossSalary,
  //   netSalary: clientAffordability.netSalary,
  //   deductions: clientAffordability.deductions,
  //   disposableIncome: clientAffordability.disposableIncome,
  //   expensesHousing: clientAffordability.expensesHousing,
  //   expensesTransport: clientAffordability.expensesTransport,
  //   expensesConsumables: clientAffordability.expensesConsumables,
  //   expensesMedical: clientAffordability.expensesMedical,
  //   expensesWater: clientAffordability.expensesWater,
  //   expensesOther: clientAffordability.expensesOther,
  //   expensesOtherDebt: clientAffordability.expensesOtherDebt,
  //   expensesEducation: clientAffordability.expensesEducation,
  //   clientRefId
  // };

  // useEffect(() => {
  //   setAffordData(initialValue);
  // }, []);

  const formik = useFormik({
    initialValues: clientAffordability,
    enableReinitialize: true,
    validationSchema: AffordabilitySchema,
    onSubmit: (values) => {
      console.log('Affordability before that 1', affordData);
      handleFormUpdate(values);
    }
  });

  const handleFormUpdate = (e) => {
    e.clientRefId = clientRefId;
    saveAffordabilityDetails(e);
  };

  const saveAffordabilityDetails = (info) => {
    const jsonClient = [];
    jsonClient.push(info);
    console.log('affordability stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/saveaffordabilitydetails`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // setClientRefId(result.clientID);
          // setCurrentClient(result);
          <Alert variant="filled" severity="success">
            Client Saved Successfully!
          </Alert>;
        },
        (error) => {
          <Alert variant="filled" severity="error">
            Error in Saving Client!, {error}
          </Alert>;
        }
      );
  };

  // const handleChanges = (e) => {
  //   setTotExpenses(formik.values.housing + formik.values.transport + formik.values.medical);
  //   setFieldValue('totalExpenses', e.target.value);
  //   console.log('Total Expenses', totExpenses);
  // };

  const { setFieldValue } = formik;

  return (
    <>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Typography variant="h6" gutterBottom>
                Affordability Info...
              </Typography>
              <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={4} container spacing={2} justifyContent="center" alignItems="center">
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={6}>
                      <Controls.InputNumber name="grossSalary" label="Gross Salary..." />
                      <Controls.InputNumber name="netSalary" label="Net Salary..." />
                      <Controls.InputNumber name="deductions" label="Total Expenses..." />
                      <Controls.InputNumber name="disposableIncome" label="Disposable Income..." />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4} container spacing={2} justifyContent="center" alignItems="center">
                  <Grid container direction="column">
                    <Grid item xs={2} sm={2}>
                      <Controls.InputNumber name="expensesHousing" label="Housing" />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Controls.InputNumber name="expensesTransport" label="Transport" />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Controls.InputNumber name="expensesMedical" label="Medical" />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Controls.InputNumber name="expensesEducation" label="Education" />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Controls.InputNumber name="expensesWater" label="Utilities" />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Controls.InputNumber name="expensesOther" label="Other Expenses" />
                    </Grid>
                    <Grid item xs={2} sm={2}>
                      <Controls.InputNumber name="expensesOtherDebt" label="Other Debt" />
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={8} container spacing={2} justifyContent="center" alignItems="center">
                  <Controls.Button>Submit Affordability</Controls.Button>
                </Grid> */}
                <Grid
                  margin={2}
                  container
                  direction="row"
                  justifyContent="right"
                  alignItems="right"
                >
                  <Grid item xs={12} sm={1} marginRight={1}>
                    <Controls.Button type="submit" variant="contained" startIcon={<SaveIcon />}>
                      Save...
                    </Controls.Button>
                  </Grid>
                  <Grid item xs={12} sm={1}>
                    <Button
                      variant="outlined"
                      startIcon={<UpdateIcon />}
                      // onClick={() => handleNewClient()}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
    </>
  );
}
